import ToolCalcLinkCard from './ToolCalcLinkCard';
export default ToolCalcLinkCard;
